import { FormNameEnum } from '@alice-financial/alice-sdk'
import { QuestionPage } from '../../survey/types'
import { useOrgFormStatus } from '../survey/useOrgFormFields'
import { payrollProcess } from './PayrollProcessInputs'
import { terminationProcess } from './TerminationProcessInputs'

export const FORM_NAME = FormNameEnum.PayrollOps
export const FORM_VERSION = 1

export const PAGES: readonly QuestionPage[] = [payrollProcess, terminationProcess]
/** * END FORM CONFIGURATION ***/

export const usePayrollOpsFormStatus = (orgId: number) => useOrgFormStatus(orgId, FORM_NAME, FORM_VERSION)
